import React, { useState, useEffect, useCallback, useContext } from "react";
import searchApiService from "../service/searchApiService";
import { useConfig } from "./useConfig";

const FiltersContext = React.createContext();

export const FiltersProvider = ({ children }) => {
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [error, setError] = useState();
  const [isLoading, setLoading] = useState(false);
  const [initialFilters, setInitialFilters] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [order, setOrder] = useState("relevancia");
  const [search, setSearch] = useState({ input: "" });
  const [anchor, setAnchor] = useState("");
  const [cacheKey, setCacheKey] = useState("");
  const [searchKeyCount, setSearchKeyCount] = useState(0);
  const [searchKeyNumber, setSearchKeyNumber] = useState(0);

  const { customParams } = useConfig();

  const getFiltersQuery = selectedFilters.map(({ name, values }) => ({
    facet: name,
    values,
  }));

  const clearFilters = (customParamsTriggered = false) => {
    setData(null);
    setPage(1);
    if (!customParamsTriggered) setSelectedFilters([]);
    setCacheKey(null);
  };

  const handleError = (error) => {
    console.error(error);
    setError(true);
    setData(null);
    setLoading(false);
  };

  const runQuery = useCallback(
    async (uuid, word, anchor) => {
      if (anchor && !word) word = " ";
      if (!uuid || !word) return;

      let userCustomParams = "";
      Object.entries(customParams)?.map(
        ([paramKey, paramValue]) =>
          (userCustomParams = userCustomParams + `&${paramKey}=${paramValue}`)
      );

      const handleSuccess = (res) => {
        setError(false);
        const data = res.data;
        setData(data);
        setInitialFilters(data.meta?.filters_applied || []);
        setPage(res.data.meta.pages_current);
        // setOrder(res.data.meta.sort_prop);
        setCacheKey(res.data.cacheKey || "");
        setLoading(false);
        return data;
      };

      const fetchApi = async () =>
        await searchApiService
          .getMetaResults(uuid, word, anchor, userCustomParams)
          .then(handleSuccess)
          .catch(handleError);

      setLoading(true);
      return await fetchApi();
    },
    [customParams]
  );

  useEffect(() => {
    runQuery();
  }, [runQuery]);

  return (
    <FiltersContext.Provider
      value={{
        data,
        isLoading,
        error,
        refetch: runQuery,
        selectedFilters,
        changeFilter: setSelectedFilters,
        order,
        changeOrder: setOrder,
        page,
        changePage: setPage,
        getFiltersQuery,
        search,
        setSearch,
        searchKeyNumber,
        setSearchKeyNumber,
        clearFilters,
        setData,
        initialFilters,
        cacheKey,
        setCacheKey,
        anchor,
        setAnchor,
        searchKeyCount,
        setSearchKeyCount,
        setLoading,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => {
  const {
    data,
    isLoading,
    error,
    refetch,
    selectedFilters,
    changeFilter,
    order,
    changeOrder,
    page,
    changePage,
    getFiltersQuery,
    search,
    setSearch,
    searchKeyNumber,
    setSearchKeyNumber,
    clearFilters,
    setData,
    initialFilters,
    cacheKey,
    setCacheKey,
    anchor,
    setAnchor,
    searchKeyCount,
    setSearchKeyCount,
    setLoading,
  } = useContext(FiltersContext);
  return {
    data,
    isLoading,
    error,
    refetch,
    selectedFilters,
    changeFilter,
    order,
    changeOrder,
    page,
    changePage,
    getFiltersQuery,
    search,
    setSearch,
    searchKeyNumber,
    setSearchKeyNumber,
    clearFilters,
    setData,
    initialFilters,
    cacheKey,
    setCacheKey,
    anchor,
    setAnchor,
    searchKeyCount,
    setSearchKeyCount,
    setLoading,
  };
};
